import React, { useContext, useEffect, useState } from 'react'
import { useParams, useNavigate, Link } from 'react-router-dom'
import { Card, Row, Container, Col, Button, Modal } from 'react-bootstrap';
import "./Profile.css"
import { apiGetUserByEmail } from '../api/api'
import Avatar from '../img/avatar.jpg'
import { ReactComponent as TikTokLogo } from '../img/tiktok.svg'
import { ReactComponent as TwitterLogo } from '../img/twitter.svg'
import { ReactComponent as InstagramLogo } from '../img/instagram.svg'
import { ReactComponent as LinkedInLogo } from '../img/linkedin.svg'

const ProfileRead = () => {
	let { email } = useParams()
	const [profile, setProfile] = useState('');

	const fetchUserData = async (e) => {
		apiGetUserByEmail(email).then((res) => {
			console.log(res.data)
			setProfile(res.data)
		}).catch(error => {
			console.log(error.response)
		})
	}

	useEffect(() => {
		fetchUserData(email)
	}, [])

	return (
		<div className="profile">
			<Container >
				<Card className="profile-card">
					<Row className="no-gutters">
						<Col xs="4" className="col-0-right-padding-avatar">
							<div className="upper-profile-blank">
								<div className='avatar-container'>
									{profile && profile.image ?
										<img src={profile.image} className='avatar' alt='user profile'></img>
										:
										<img src={Avatar} className='avatar' alt='user profile'></img>
									}
								</div>
							</div>
						</Col>
						<Col className="col-0-left-padding">
							<div className="upper-profile">
								<div className="profile-username">
									{profile && profile.username}
								</div>
							</div>
						</Col>
						<div class="w-100"></div>
						<Col xs="4" className="col-0-right-padding">
							<div className="profile-social-media">
								{profile && profile.tiktok && profile.tiktok !== '-' ?
									<a href={"https://www.tiktok.com/@" + profile.tiktok}
										target="_blank"
										rel="noopener noreferrer">
										<TikTokLogo className='tiktok' />
									</a> :
									null
								}
								{profile && profile.twitter && profile.twitter !== '-' ?
									<a href={"https://www.twitter.com/" + profile.twitter}
										target="_blank"
										rel="noopener noreferrer">
										<TwitterLogo className='twitter' />
									</a> :
									null
								}

								{profile && profile.instagram && profile.instagram !== '-' ?
									<a href={"https://www.instagram.com/" + profile.instagram}
										target="_blank"
										rel="noopener noreferrer">
										<InstagramLogo className='instagram' />
									</a> :
									null
								}

								{profile && profile.linkedin && profile.linkedin !== '-' ?
									<a href={"https://www.linkedin.com/in/" + profile.linkedin}
										target="_blank"
										rel="noopener noreferrer">
										<LinkedInLogo className='linkedin' />
									</a> :
									null
								}
							</div>
						</Col>
						<Col className="col-0-left-padding">
							<div className="profile-information">
								<div>
									Full Name: {profile && profile.name}
									<br />
									Faculty: {profile && profile.faculty}
									<br />
									Class Of: {profile && profile.classOf}
									<br />
									Bio: {profile && profile.description}
								</div>
							</div>
						</Col>
					</Row>
				</Card>
			</Container>
		</div>
	)
}

export default ProfileRead